import axios from 'axios'
import {all, fork, takeEvery, call, put} from 'redux-saga/effects'
import {API_BASE_URL, KAKAO_AUTH_URL, NAVER_AUTH_URL} from "../constants/config";
import actionTypes from "../constants/actionTypes";


function* check() {
    try {
        const token = localStorage.getItem('token');
        const config = {
            headers: {
                'Authorization': `${token}`
            }
        };
        const data = yield call(axios.get, API_BASE_URL + "/auth/authorize", config);
        yield put({
            type: actionTypes.LOGIN_CHECK_SUCCEED,
            loginData: data
        })
    } catch (e) {
        yield put({
            type: actionTypes.LOGIN_CHECK_FAILED,
        })
    }

}

function* watchCheck() {
    yield takeEvery(actionTypes.LOGIN_CHECK, check)
}

export default function* checkLoginSaga(action) {
    yield all([
        fork(watchCheck)
    ])
}
